import Vue from 'vue'
import Router from 'vue-router'

const Home = resolve => require(['@/views/Home'], resolve)
const PinyinTune = resolve => require(['@/views/PinyinTune'], resolve)
const Translate = resolve => require(['@/views/Translate'], resolve)
const PinyinCard = resolve => require(['@/views/PinyinCard'], resolve)
const Stroke = resolve => require(['@/views/Stroke'], resolve)
const Stroke2 = resolve => require(['@/views/Stroke2'], resolve)
const Copybook = resolve => require(['@/views/Copybook'], resolve)
const CopybookPrint = resolve => require(['@/views/CopybookPrint'], resolve)
const PinyinBook = resolve => require(['@/views/PinyinBook'], resolve)
const PinyinBookPrint = resolve => require(['@/views/PinyinBookPrint'], resolve)
const BookPinyin = resolve => require(['@/views/BookPinyin'], resolve)
const BookPinyinPrint = resolve => require(['@/views/BookPinyinPrint'], resolve)
const Dictionary = resolve => require(['@/views/Dictionary'], resolve)
const ChineseDictionary = resolve => require(['@/views/ChineseDictionary'], resolve)
const Idiom = resolve => require(['@/views/Idiom'], resolve)
const IdiomDetail = resolve => require(['@/views/IdiomDetail'], resolve)
const Saying = resolve => require(['@/views/Saying'], resolve)
const Saying2 = resolve => require(['@/views/Saying2'], resolve)
const Antonym = resolve => require(['@/views/Antonym'], resolve)
const SimilarWord = resolve => require(['@/views/SimilarWord'], resolve)
const Radical = resolve => require(['@/views/Radical'], resolve)
const RadicalDetail = resolve => require(['@/views/RadicalDetail'], resolve)
const StrokeNumber = resolve => require(['@/views/StrokeNumber'], resolve)
const StrokeDetail = resolve => require(['@/views/StrokeDetail'], resolve)
const Pinyin = resolve => require(['@/views/Pinyin'], resolve)
const PinyinDetail = resolve => require(['@/views/PinyinDetail'], resolve)
const WordDetail = resolve => require(['@/views/WordDetail'], resolve)
const Word3500 = resolve => require(['@/views/Word3500'], resolve)
const ChineseCard = resolve => require(['@/views/ChineseCard'], resolve)
const PhoneticNotation = resolve => require(['@/views/PhoneticNotation'], resolve)
const PhoneticNotationTable = resolve => require(['@/views/PhoneticNotationTable'], resolve)
const ExerciseBook = resolve => require(['@/views/ExerciseBook'], resolve)
const Copywriting = resolve => require(['@/views/Copywriting'], resolve)
const CommercialCode = resolve => require(['@/views/CommercialCode'], resolve)
const Diy = resolve => require(['@/views/Diy'], resolve)
const Couplet = resolve => require(['@/views/Couplet'], resolve)
const Error404 = resolve => require(['@/views/error/Error404'], resolve)

Vue.use(Router)

let routes = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/pinyinTune',
        component: PinyinTune
    },
    { path: '/dictation', component: resolve => require(['@/views/Dictation'], resolve) },
    { path: '/stroke/weapp', component: resolve => require(['@/views/StrokeWeapp'], resolve) },
    { path: '/saying/plugin', component: resolve => require(['@/views/SayingPlugin'], resolve) },
    {
        path: '/commercialCode',
        component: CommercialCode
    },
    {
        path: '/translate',
        component: Translate
    },
    {
        path: '/pinyin/card',
        component: PinyinCard
    },
    {
        path: '/stroke',
        component: Stroke
    },
    {
        path: '/stroke2',
        component: Stroke2
    },
    {
        path: '/copybook',
        component: Copybook
    },
    {
        path: '/copybook/print',
        component: CopybookPrint
    },
    {
        path: '/pinyinBook',
        component: PinyinBook
    },
    {
        path: '/pinyinBook/print',
        component: PinyinBookPrint
    },
    {
        path: '/book/pinyin',
        component: BookPinyin
    },
    {
        path: '/book/pinyin/print',
        component: BookPinyinPrint
    },
    {
        path: '/dictionary',
        component: Dictionary
    },
    {
        path: '/dictionary/chinese',
        component: ChineseDictionary
    },
    {
        path: '/idiom',
        component: Idiom
    },
    {
        path: '/idioms/:word',
        component: IdiomDetail
    },
    {
        path: '/saying',
        component: Saying
    },
    {
        path: '/saying2',
        component: Saying2
    },
    {
        path: '/antonym',
        component: Antonym
    },
    {
        path: '/similarWord',
        component: SimilarWord
    },
    {
        path: '/radicals',
        component: Radical
    },
    {
        path: '/radicals/:radical',
        component: RadicalDetail
    },
    {
        path: '/words/:word',
        component: WordDetail
    },
    {
        path: '/word/3500',
        component: Word3500
    },
    {
        path: '/stroke/number',
        component: StrokeNumber
    },
    {
        path: '/strokes/:number',
        component: StrokeDetail
    },
    {
        path: '/pinyins',
        component: Pinyin
    },
    {
        path: '/pinyins/:pinyin',
        component: PinyinDetail
    },
    {
        path: '/chinese/card',
        component: ChineseCard
    },
    {
        path: '/phoneticNotation',
        component: PhoneticNotation
    },
    {
        path: '/phoneticNotation/table',
        component: PhoneticNotationTable
    },
    {
        path: '/exerciseBook',
        component: ExerciseBook
    },
    {
        path: '/copywriting',
        component: Copywriting
    },
    {
        path: '/diy',
        component: Diy
    },
    {
        path: '/couplet',
        component: Couplet
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js